import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { withPreferredLocation } from 'src/app/hocs';
import { segmentTrack } from 'src/app/state/actions';
import { getCurrentPathname } from 'src/app/state/selectors';
import { closeChat, isChatOpenSelector } from 'src/app/state/slices/chat';
import type { Dispatch, RootState } from 'src/app/state/store';

import { Renderer } from './Renderer';

interface MapStateReturnType {
  isChatOpen: boolean;
  currentLocation: string;
  previousLocation: string;
}

const connector = connect(
  (state: RootState): MapStateReturnType => {
    const isChatOpen = isChatOpenSelector(state);

    return {
      isChatOpen,
      currentLocation: getCurrentPathname(state),
      previousLocation: state.routerLocation?.previous?.pathname,
    };
  },
  (dispatch: Dispatch) => ({
    dispatchSegmentTrack: (event: UnifiedEvent, payload: any = {}) => dispatch(segmentTrack(event, payload)),
    onResetChat: () => dispatch(closeChat()),
  })
);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export const TextUs = compose(connector, withPreferredLocation)(Renderer);
